import { get } from "./index";
import { GET_POSTS_URL_PARAM } from "../utils/constant";

//Post
export const getPosts = () => get(GET_POSTS_URL_PARAM);
